//imports
import {
    FIRMWARE_REQUESTS_DETAILS_OPEN_MODAL,
    FIRMWARE_REQUESTS_DETAILS_REQUEST,
    FIRMWARE_REQUESTS_DETAILS_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    data: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FIRMWARE_REQUESTS_DETAILS_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, data: action.payload.data }

        case FIRMWARE_REQUESTS_DETAILS_REQUEST:
            return { ...state, loading: true }

        case FIRMWARE_REQUESTS_DETAILS_RESULT:
            return { ...state, loading: false, result: action.payload.data }

        case CLEAR_REDUX:
            return ["", "FIRMWARE_REQUESTS_DETAILS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};